import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

/**
 * CreateAccountDialog component.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.showCreateAccount - Flag indicating whether to show the create account dialog.
 * @param {function} props.setShowCreateAccount - Function to update the showCreateAccount state.
 * @returns {JSX.Element} The CreateAccountDialog component.
 */
const CreateAccountDialog = ({ showCreateAccount, setShowCreateAccount }) => {
    return (
        <Dialog open={showCreateAccount} onClose={() => setShowCreateAccount(false)}>
            <DialogTitle>Sign in or Create an Account</DialogTitle>
            <DialogContent>
                <p>Sign in or <a href="/user/register" target='register'>create an account</a> to access premium features.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowCreateAccount(false)} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateAccountDialog;
